import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.css'],
  standalone: true
})
export class GenericModalComponent implements OnInit {
  @Input() title: string;
  @Input() text: string;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }

  close(result) {
    if (result) {
      this.activeModal.close();
    } else {
      this.activeModal.dismiss();
    }
  }
}
